import React from 'react';
import { FreeLayout } from 'Layouts';
import { useStore } from 'Hooks/useStore';
import './SupportedDevices.css';

export function SupportedDevicesContainer() {
  const { supportedDevices } = useStore('appConfig.screens');
  return <FreeLayout className="supportedDevicesPage" screenName={supportedDevices} />;
}
